import React, { useEffect, useState, useRef } from "react";
import "./TitleSubtitlePageHeader.css";
import { ReactComponent as LeftBoxGraphic } from "images/background/hero-section-red-triangle.svg";
import { ReactComponent as RightGraphic } from "images/background/right-box-graphic.svg";
import { ReactComponent as RightBox } from "images/background/software-solution-graphic-red.svg";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import "./Hardware.css";

export default function RequestAMemo({ title, subtitle, subtitleColorGreen }) {
  const location = useLocation();
  const myRef = useRef(null);
  useEffect(() => {
    if (location.state?.hash === "contactUs") {
      myRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);
  return (
    <div>
      <div className="title-subtitle-page-header" >
        <div className="hg-bg-left">
          <LeftBoxGraphic />
        </div>
        <div className="rightFrame">
          <RightGraphic className="RightFrame-svg" />
        </div>
        <div className="rightBox">
          <RightBox className="RightBox-svg" />
        </div>
        <div className="header" ref={myRef} id="contactUs">
          <h2 className="mb-5"><FormattedMessage id={title} /></h2>
          <p className="primary text-bold">
            <FormattedMessage id={subtitle} />
          </p>
        </div>
        <div>
          <div className="leftFrame">
          </div>
        </div>
      </div>
    </div>
  );
}
